import { jwtDecode } from 'jwt-decode';

// Provider-agnostic sessionStorage token helpers. Both providers store the
// same three tokens under the same keys

// Thrown in place of sending a request once the session is gone and the user is
// already being redirected to /unauthorized.
export class SessionExpiredError extends Error {
  constructor() {
    super('Session expired');
    this.name = 'SessionExpiredError';
  }
}

// Set while that redirect is in flight so the failing callers' error toasts are
// suppressed; cleared by the next successful sign-in or refresh.
let sessionExpired = false;

export function markSessionExpired() {
  sessionExpired = true;
}

export function isSessionExpired() {
  return sessionExpired;
}

export function setTokens(
  id_token = null,
  access_token = null,
  refresh_token = null
) {
  if (id_token) sessionStorage.setItem('id_token', id_token);
  if (access_token) sessionStorage.setItem('access_token', access_token);
  if (refresh_token) sessionStorage.setItem('refresh_token', refresh_token);
  if (id_token) sessionExpired = false;
}

export function clearTokens() {
  sessionStorage.removeItem('id_token');
  sessionStorage.removeItem('access_token');
  sessionStorage.removeItem('refresh_token');
}

// Returns active decoded token
export function currentSession() {
  const token = sessionStorage.getItem('id_token');
  if (!token) return null;

  return jwtDecode(token);
}
